export enum SettingsInboxesDataEventObjectsEnum {
  INBOX_ACCESS = 'inbox_access',
}
